<div class="window-container">
    <div class="alert-container">
        <div class="modal-title">{{ "endOfVisit.title" | translate}}</div>
        <div class="modal-description">{{ "endOfVisit.description" | translate}} {{ tour.organisation.name }}.</div>
        <div class="modal-controls">
            <button class="btn rounded-pill btn-modal-action btn-modal" (click)="onConfirm()">
                {{ "Thank you" | translate }}</button>
        </div>
    </div>
</div>
